export interface BrowserData {
  height: string;
  width: string;
  colorDepth: string;
  timezone: string;
  clearSaleSession?: string;
}

export interface BrowserDataApi {
  src_height: string;
  src_width: string;
  src_color_depth: string;
  timezone: string;
}

export const getBrowserData = (): BrowserData => ({
  height: `${window.screen.height}`,
  width: `${window.screen.width}`,
  colorDepth: `${window.screen.colorDepth}`,
  timezone: `${new Date().getTimezoneOffset()}`,
  clearSaleSession:
    (document.getElementById("CSSessionInput") as HTMLInputElement)?.value ||
    "",
});

export const serializeBrowserData = (data: BrowserData): BrowserDataApi => ({
  src_height: data.height,
  src_width: data.width,
  src_color_depth: data.colorDepth,
  timezone: data.timezone,
});
